import { render, staticRenderFns } from "./image-lightbox.vue?vue&type=template&id=286ad61a&scoped=true&"
import script from "./image-lightbox.vue?vue&type=script&lang=ts&"
export * from "./image-lightbox.vue?vue&type=script&lang=ts&"
import style0 from "./image-lightbox.vue?vue&type=style&index=0&id=286ad61a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ad61a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286ad61a')) {
      api.createRecord('286ad61a', component.options)
    } else {
      api.reload('286ad61a', component.options)
    }
    module.hot.accept("./image-lightbox.vue?vue&type=template&id=286ad61a&scoped=true&", function () {
      api.rerender('286ad61a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/estates/image-lightbox.vue"
export default component.exports